import * as React from 'react';
const SvgClose = (props) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} {...props}>
      <g fill={props.fill ? props.fill : '#4A4A4A'} fillRule="nonzero">
         <path d="m17.1 18.1 20.8 20.8zM18.587 16.615l20.798 20.798a2.1 2.1 0 1 1-2.972 2.972L15.615 19.587a2.1 2.1 0 1 1 2.972-2.972M37.9 18.1 17.1 38.9z" />
         <path d="M36.413 16.615 15.615 37.413a2.1 2.1 0 1 0 2.972 2.972l20.798-20.798a2.1 2.1 0 1 0-2.972-2.972" />
      </g>
   </svg>
);
export default SvgClose;
